module.exports = __webpack_public_path__ + "img/fondologin.809c3b89.jpg";